// 403 do RBAC: o backend responde `{"error":"missing permission: olts:write"}` (inglês técnico).
// O interceptor do axios troca pelo texto abaixo para todo `catch (err.response?.data?.error)` da app
// exibir algo que o operador entende (RVF-02) — mesmo ponto único do `coleta_ocupada`.

const TEXT = {
  pt: (perm) => `Seu perfil não tem permissão para esta ação${perm ? ` (${perm})` : ''}. Peça a um administrador para liberar.`,
  en: (perm) => `Your profile is not allowed to do this${perm ? ` (${perm})` : ''}. Ask an administrator to grant it.`,
  es: (perm) => `Su perfil no tiene permiso para esta acción${perm ? ` (${perm})` : ''}. Pida a un administrador que lo habilite.`,
};

/** Devolve o texto amigável quando `error` é o 403 de permissão; senão `null`. */
export function forbiddenMessage(error, lang = 'pt') {
  const m = /^missing permission:\s*(\S+)/i.exec(String(error || ''));
  if (!m) return null;
  return (TEXT[lang] || TEXT.pt)(m[1]);
}
